<div class="text-center fw-bold mt-4 pb-4">
  {{ "common.notFound" | transloco }}
</div>
